<template>
  <div id="registerPage">
    <div data-html2canvas-ignore="true" v-show="loader">
      <Loader />
      <div class="spinner-border" role="status"><span class="sr-only">Loading...</span></div>
    </div>
    <div class="weavrLogoContainer">
      <img src="img/brand/weavr.svg" height="100%" alt="Brand Logo Full" />
    </div>
    <div class="container-fluid d-flex align-items-center">
      <div class="left-img">
        <div class="login-page-img">
          <img src="img/loginPageLeftImg.png" class="img-fluid" alt="Brand Logo Full" />
        </div>
      </div>
      <div class="form-container">
        <b-form @submit="registerClient">
          <h2 class="mainHeading">Sign Up</h2>
          <template v-if="!userVerified">
            <p class="subHeading">Enter your business details</p>
            <div class="d-flex justify-content-between negative-margin gap">
              <div class="input-group">
                <label for="firstName">First Name</label>
                <input id="firstName" type="text" required v-model="firstName" placeholder="Enter your first name.">
              </div>
              <div class="input-group">
                <label for="lastName">Last Name</label>
                <input id="lastName" type="text" required v-model="lastName" placeholder="Enter your last name.">
              </div>
            </div>
            <div class="input-group">
              <label for="email">Email</label>
              <input id="email" type="email" required v-model="email" placeholder="Enter your email address">
            </div>
            <div class="input-group">
              <label for="companyName">Company Name</label>
              <input id="companyName" type="text" required v-model="companyName" placeholder="Enter your company name">
            </div>
            <div class="input-group">
              <label for="brandNames">Brand Name(s)</label>
              <input id="brandNames" type="text" required v-model="brandNames"
                placeholder="Enter comma separated brand name(s)">
            </div>
            <div class="dropdown-group gap">
              <div>
                <div id="dropdown">
                  <label for="">Region</label>
                  <div class="d-flex" @click="showRegionDropdown = !showRegionDropdown">
                    <span class="country-flag">
                      <img :src="require(`../../../public/country-flags-svg/${selectedCountry.image}`)"
                        alt="country-flag">
                    </span>
                    <span class="d-flex flex-column justify-content-center ml-2 mr-3">
                      <i class="fa fa-caret-up"></i>
                      <i class="fa fa-caret-down"></i>
                    </span>
                    <span>
                      {{ selectedCountry.name }}
                    </span>
                  </div>
                </div>
                <div id="country-dropdown" v-if="showRegionDropdown">
                  <div id="country-search" class="mx-3 mt-2 mb-3">
                    <input type="search" v-model="countrySearchQuery">
                    <span><i class="fa fa-search"></i></span>
                  </div>
                  <div v-for="country of countryCodes"
                    v-if="country.name.toLowerCase().includes(countrySearchQuery.toLowerCase()) || country.dial_code.toLowerCase().includes(countrySearchQuery.toLowerCase())"
                    :key="country.code" class="country-list" @click="selectedCountry = country"
                    :class="country.name.trim() === selectedCountry.name.trim() ? 'active' : ''">
                    <span class="country-flag mr-2">
                      <img :src="require(`../../../public/country-flags-svg/${country.image}`)" alt="country-flag">
                    </span>
                    <span class="mr-2">{{ country.name }}</span>
                    <span class="dial-code">{{ country.dial_code }}</span>
                  </div>
                </div>
              </div>
              <div class="input-group" style="width: 40%; margin-top: 2px !important;">
                <label for="phoneNumber">Phone Number</label>
                <div class="phone-code">
                  <input id="phoneNumber" type="text" required v-model="phoneNumber"
                    placeholder="Enter your phone number">
                  <span>{{ selectedCountry.dial_code }}</span>
                </div>
              </div>
            </div>
            <button type="button" class="primarycolor w-100 mb-3" @click="checkEmail">Next</button>
          </template>
          <template v-else-if="userVerified">
            <p class="subHeading">Almost done. Enter your password and you are all set.</p>
            <div class="input-group negative-margin relative">
              <label for="password">Password</label>
              <input id="password" :type="showPassword ? 'text' : 'password'" v-model="password"
                placeholder="Enter password.">
              <i class="fa fa-eye showhidePassword" v-if="!showPassword" @click="showPassword = true"></i>
              <i class="fa fa-eye-slash showhidePassword" v-if="showPassword" @click="showPassword = false"></i>
            </div>
            <b-row class="validity-req-list mt-2">
              <b-col cols="6" class="my-1" v-for="validityReq of passwordRequirements" :key="validityReq.id"
                :style="validityReq.color">
                <span class="mr-2">
                  <i class="fa fa-circle" :style="validityReq.color"></i>
                </span>
                <span>{{ validityReq.msg }}</span>
              </b-col>
            </b-row>
            <div>
              <div class="input-group negative-margin">
                <label for="confPassword">Confirm Password</label>
                <input id="confPassword" :type="showConfPassword ? 'text' : 'password'" v-model="confPassword"
                  placeholder="Confirm Password.">
                <i class="fa fa-eye showhidePassword" v-if="!showConfPassword" @click="showConfPassword = true"></i>
                <i class="fa fa-eye-slash showhidePassword" v-if="showConfPassword"
                  @click="showConfPassword = false"></i>
              </div>
              <div class="mt-1" :style="registerValidation.confirmPassword.color">{{
                registerValidation.confirmPassword.msg }}</div>
            </div>
            <div class="d-flex align-items-center mt-2 mb-3">
              <input type="checkbox" name="" id="TnC" class="mr-2" required v-model="termsAndCondition">
              <label for="TnC" class="mb-0">I agree to the <span class="redirect">Terms and Conditions</span></label>
            </div>
            <button type="submit" class="primarycolor w-100 mb-3">Sign Up</button>
          </template>
          <h4 class="subHeading">Already registered? <span class="redirect" @click="$router.push('/')">Login</span></h4>
        </b-form>
      </div>
    </div>
  </div>
</template>

<script>
import countryCodes from "../../json/countryCodes.json";
import Loader from "../Components/Loader.vue"
export default {
  name: 'Register',
  components: {
    Loader
  },
  data() {
    return {
      loader: false,
      userVerified: false,
      firstName: "",
      lastName: "",
      email: "",
      companyName: "",
      brandNames: "",
      phoneNumber: "",
      password: "",
      showPassword: false,
      confPassword: "",
      showConfPassword: false,
      termsAndCondition: false,
      countryCodes: null,
      selectedCountry: {
        "name": "India",
        "code": "IN",
        "emoji": "🇮🇳",
        "unicode": "U+1F1EE U+1F1F3",
        "image": "IN.svg",
        "dial_code": "+91"
      },
      showRegionDropdown: false,
      countrySearchQuery: "",
      passwordRequirements: [
        {
          msg: 'Have at least a number',
          color: '',
          id: 1,
          criteria: /\d/,
          valid: false
        },
        {
          msg: 'Have at least one lowercase letter',
          color: '',
          id: 2,
          criteria: /[a-z]/,
          valid: false
        },
        {
          msg: 'Have at least one uppercase letter',
          color: '',
          id: 3,
          criteria: /[A-Z]/,
          valid: false
        },
        {
          msg: 'Have at least one special character',
          color: '',
          id: 4,
          criteria: /[!@#$%^&*(),.?":{}|<>]/,
          valid: false
        },
        {
          msg: 'Have minimum 8 characters',
          color: '',
          id: 5,
          criteria: /^.{8,}$/,
          valid: false
        },
      ],
      registerValidation: {
        // email: {
        //   flag: "invalid",
        //   msg: ""
        // },
        // companyName: {

        // }
        confirmPassword: {
          color: '',
          msg: '',
          valid: false
        }
      }
    }
  },
  created() {
    this.countryCodes = countryCodes.sort((a, b) => {
      const nameA = a.name.toLowerCase();
      const nameB = b.name.toLowerCase();

      if (nameA < nameB) {
        return -1;
      }
      if (nameA > nameB) {
        return 1;
      }
      return 0;
    });
  },
  mounted() {

  },
  watch: {
    password: {
      handler(newVal, oldVal) {
        this.passwordRequirements.forEach(req => {
          if (req.criteria.test(newVal)) {
            req.color = 'color: #1ACF85';
            req.valid = true;
          } else {
            req.color = 'color: #FD5542';
            req.valid = false;
          }
        })
      },
      deep: true
    },
    confPassword(newVal, oldVal) {
      if (!newVal.length) {
        this.registerValidation.confirmPassword.color = '';
        this.registerValidation.confirmPassword.msg = '';
        this.registerValidation.confirmPassword.valid = false;
      } else if (newVal !== this.password) {
        this.registerValidation.confirmPassword.color = 'color: #FD5542';
        this.registerValidation.confirmPassword.msg = 'Passwords does not match';
        this.registerValidation.confirmPassword.valid = false;
      } else {
        this.registerValidation.confirmPassword.color = 'color: #1ACF85';
        this.registerValidation.confirmPassword.msg = 'Passwords matched';
        this.registerValidation.confirmPassword.valid = true;
      }
    }
  },
  methods: {
    loginClient() {

    },
    checkEmail() {
      this.userVerified = false;

      const url = "/api/demo/register/verify";
      const payload = {
        email_address: this.email.trim(),
        company_name: this.companyName.trim(),
        country_code: this.selectedCountry.dial_code.trim(),
        phone_number: this.phoneNumber.trim(),
      }

      if (!this.firstName) {
        this.$bvToast.toast(`Please enter your first name.`, {
          title: "Weavr Sense",
          variant: "danger",
          toaster: "b-toaster-bottom-center",
          autoHideDelay: 3000
        });
        return;
      }
      if (!this.lastName) {
        this.$bvToast.toast(`Please enter your last name.`, {
          title: "Weavr Sense",
          variant: "danger",
          toaster: "b-toaster-bottom-center",
          autoHideDelay: 3000
        });
        return;
      }
      if (!this.email) {
        this.$bvToast.toast(`Please enter your email.`, {
          title: "Weavr Sense",
          variant: "danger",
          toaster: "b-toaster-bottom-center",
          autoHideDelay: 3000
        });
        return;
      }
      if (!this.companyName) {
        this.$bvToast.toast(`Please enter your company name.`, {
          title: "Weavr Sense",
          variant: "danger",
          toaster: "b-toaster-bottom-center",
          autoHideDelay: 3000
        });
        return;
      }
      if (!this.phoneNumber) {
        this.$bvToast.toast(`Please enter your phone number.`, {
          title: "Weavr Sense",
          variant: "danger",
          toaster: "b-toaster-bottom-center",
          autoHideDelay: 3000
        });
        return;
      }
      
      this.loader = true;
      this.$http.post(url, payload).then(response => {
        this.loader = false;
        this.userVerified = true;
      }).catch(err => {
        this.loader = false;
        this.userVerified = false;
        this.$bvToast.toast(`${err.body.summary}`, {
          title: "Weavr Sense",
          variant: "danger",
          toaster: "b-toaster-bottom-center",
          autoHideDelay: 3000
        });
      })
    },
    registerClient(e) {
      e.preventDefault();

      let tempBrandNames = []
      if(this.brandNames.length) {
        tempBrandNames = this.brandNames.split(",").map(brand => brand.trim());
      }

      /* Validations */
      for (let validateField of this.passwordRequirements) {
        if (!validateField.valid) {
          this.$bvToast.toast(`Password should ${validateField.msg.toLowerCase()}.`, {
            title: "Weavr Sense",
            variant: "danger",
            toaster: "b-toaster-bottom-center",
            autoHideDelay: 3000
          });
          return;
        }
      }

      if (!this.registerValidation.confirmPassword.valid) {
        this.$bvToast.toast(`Password and confirm password do not match.`, {
          title: "Weavr Sense",
          variant: "danger",
          toaster: "b-toaster-bottom-center",
          autoHideDelay: 3000
        });
        return;
      }

      if (!this.termsAndCondition) {
        this.$bvToast.toast(`Please read the privacy policy and accept the terms and conditions.`, {
          title: "Weavr Sense",
          variant: "danger",
          toaster: "b-toaster-bottom-center",
          autoHideDelay: 3000
        });
        return;
      }

      this.loader = true;
      const url = '/api/demo/register';
      const payload = {
        first_name: this.firstName.trim(),
        last_name: this.lastName.trim(),
        country_code: this.selectedCountry.dial_code.trim(),
        phone_number: this.phoneNumber.trim(),
        company_name: this.companyName.trim(),
        brand_name: tempBrandNames,
        email_address: this.email.trim(),
        password: this.password.trim(),
      }
      this.$http.post(url, payload).then(res => {
        localStorage.setItem('userRegister', true);
        let reviewUserData = {
          data: {
            token: res.body.data.token,
            username: this.companyName,
            email: this.email
          }
        }
        localStorage.setItem("reviewUserData", JSON.stringify(reviewUserData))
        let items = [{
          name: "Form",
          url: "/demo-form",
          icon: "icon-chart"
        }]
        localStorage.vocSidebar = JSON.stringify(items);
        window.location = "#/demo-form";
        this.loader = false;
      }).catch(err => {
        console.log(`Error in registering the client::${err}`);
        this.$bvToast.toast(`${err.summary}.`, {
          title: "Weavr Sense",
          variant: "danger",
          toaster: "b-toaster-bottom-center",
          autoHideDelay: 3000
        });
        this.loader = false;
      })
    }
  }
}
</script>
<style scoped>
#registerPage {
  font-family: 'Poppins', sans-serif;
  background-color: white;
}

.showhidePassword {
  position: absolute;
  top: 40%;
  right: 1%;
  color: #C3C3C3;
  cursor: pointer;
}

.mainHeading {
  color: #000;
  font-size: 1.4rem;
  font-weight: bold;
}

.subHeading {
  font-size: 16px;
  color: #5B5B5B;
}

.redirect {
  color: var(--primary_brand) !important;
  cursor: pointer !important;
  font-weight: 600;
}

.weavrLogoContainer {
  padding: 20px 1rem;
  margin-left: .5rem;
}

.weavrLogoContainer img {
  height: 45px;
}

.container-fluid {
  height: 90vh !important;
  padding: 0 !important;
  gap: 10rem;
}

.hero-login-section {
  width: 100%;
  height: 100% !important;
}

.left-img {
  padding: 0 !important;
  width: 44%;
}

.login-page-img img {
  height: 89vh !important;
  width: 100%;
  padding-bottom: 10px;
}

.form-container {
  width: 35%;
}

.negative-margin {
  margin-bottom: -10px !important;
}

.gap {
  gap: 5%;
}

.dropdown-group {
  display: flex;
}

.dropdown-group>div:first-child {
  width: 60%;
}

#dropdown {
  position: relative;
  padding: 9px 16px;
  border-radius: 8px;
  border: 1px solid var(--primary_brand);
  cursor: pointer;
  margin-top: 10px;
}

#dropdown label {
  position: absolute;
  color: var(--primary_brand);
  background-color: white;
  top: -14px;
  left: 20px;
  font-size: 16px;
  padding-inline: 4px;
}

#dropdown i {
  font-size: 18px !important;
  margin-block: -4px !important;
  color: #5E5E5E;
  max-height: 43px;
  text-overflow: ellipsis;
}

#country-search {
  height: 40px;
  border: 1px solid var(--primary_brand-80);
  border-right: none;
  border-radius: 8px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

#country-search input {
  border: none;
  width: 90%;
  padding-inline: 16px;
}

#country-search input:focus {
  box-shadow: none !important;
  outline: none !important;
  border: none;
}

#country-search input:-webkit-autofill {
  -webkit-box-shadow: 0 0 0 1000px #fff inset !important;
  font-family: "Poppins", sans-serif !important;
}

#country-search input:-moz-autofill {
  box-shadow: 0 0 0 1000px #fff inset !important;
  font-family: "Poppins", sans-serif !important;
}

#country-search span {
  color: white;
  background-color: var(--primary_brand);
  height: 100%;
  width: 10%;
  display: flex;
  justify-content: center;
  align-items: center;
  border-top-right-radius: 7px;
  border-bottom-right-radius: 7px;
}

#country-dropdown {
  position: absolute;
  background-color: white;
  border-radius: 7px;
  max-height: 200px;
  overflow-y: auto;
  border: 1px solid #D9D9D9;
  padding-block: 10px;
  margin-top: 10px;
  width: 20%;
}

.country-list {
  display: flex;
  gap: 8px;
  align-items: center;
  padding: 7px 24px;
  cursor: pointer;
  border-bottom: 1px solid #D9D9D9;
}

.dial-code {
  border: 0.5px solid #AFAFAF;
  color: #AFAFAF;
  font-size: 12px;
  border-radius: 20px;
  padding: 4px 14px;
}

.phone-code span {
  position: absolute;
  left: 3%;
  top: 18%;
  height: 65%;
  display: flex;
  align-items: center;

}

#phoneNumber {
  padding-left: 36px;
}

.country-list:hover {
  background-color: var(--primary_brand-10);
  color: var(--primary_brand-80);
}

.country-list.active {
  background-color: var(--primary_brand);
  color: white;
}

.country-list.active>.dial-code {
  color: white;
  border-color: white;
}

.input-group {
  padding-block: 10px;
  margin-block: 10px;
  position: relative;
  display: block !important;
}

.input-group label {
  position: absolute;
  color: var(--primary_brand);
  background-color: white;
  top: -2px;
  left: 20px;
  font-size: 16px;
  padding-inline: 4px;
}

.input-group input {
  padding: 10px 16px;
  border-radius: 8px;
  border: 1px solid var(--primary_brand);
  width: 100%;
}

.input-group input:focus {
  box-shadow: none !important;
  outline: none !important;
  border: 1.5px solid var(--primary_brand) !important;
}

.input-group input:-webkit-autofill {
  -webkit-box-shadow: 0 0 0 1000px #fff inset !important;
  font-family: "Poppins", sans-serif !important;
}

.input-group input:-moz-autofill {
  box-shadow: 0 0 0 1000px #fff inset !important;
  font-family: "Poppins", sans-serif !important;
}

.error-flag {
  font-size: 12px;
  margin: 0;
  padding-top: 2px;
  padding-left: 6px;
  margin-top: 4px;
}

.error-flag .valid {
  color: green;
}

.error-flag .invalid {
  color: red;
}

.error-flag .invalid i {
  padding: 2px 3px;
  border: 1px solid red;
  border-radius: 50%;
}

.error-flag .valid i {
  padding: 2px 3px;
  border: 1px solid green;
  border-radius: 50%;
}

.country-flag img {
  width: 25px;
  height: 25px;
  border-radius: 50%;
  object-fit: cover;
}

button.primarycolor {
  background: var(--primary_brand);
  font-family: "Poppins", sans-serif;
  color: white;
  padding: 12px 25px;
  border-radius: 6px;
  letter-spacing: 0.2px;
  font-weight: bold;
  font-size: 16px;
  border: none;
}

button.primarycolor:hover {
  color: white;
  background: var(--primary_brand-80);
  /* border: 1.6px solid var(--base_color); */
}

.validity-req-list {
  font-size: 14px;
  color: #919191;
}

.validity-req-list i {
  color: #E8E8E8;
}
</style>
